export const BlurBackdrop = ({ src, style }) => (src
  ? <img aria-hidden="true" alt="" src={src} style={style} className="pointer-events-none absolute inset-0 h-full w-full scale-125 object-cover opacity-60 blur-2xl" />
  : null);
